import React from 'react'

import classnames from 'classnames'

import { ExpenseTypeEligibility } from 'core/domain/expenses/expenseTypeEligibility'

import Icon from 'common/components/general/Icon'

import { elegibilityItemMap } from './eligibilityItemMap'

import './ExpenseIcon.less'

interface ExpenseIconProps {
  expenseTypeId: ExpenseTypeEligibility
  isPremium?: boolean
}

export const ExpenseIcon: React.FC<ExpenseIconProps> = ({ expenseTypeId, isPremium }) => {
  const iconType = elegibilityItemMap.get(expenseTypeId) ?? ''
  const { NotReimbursable, HSANotEligible } = ExpenseTypeEligibility
  let iconColor = expenseTypeId === NotReimbursable || expenseTypeId === HSANotEligible

  const iconClass = classnames({
    'color-red-6': iconColor,
    'color-green-6': !iconColor,
    'color-gray-6': isPremium,
    'mr-8': true,
  })

  return (
    <div className="expense-icon">
      <Icon type={iconType} className={iconClass} fontAwesome />
    </div>
  )
}

export default ExpenseIcon
